


export const get_date_from_string = (date_str,center_text='') => {
    const serverDate = new Date(date_str);
    const dateOptions = { day: 'numeric', month: 'long'};
    const timeOptions = { hour: 'numeric', minute: 'numeric' };
    const formattedDate = serverDate.toLocaleDateString(undefined, dateOptions);
    const formattedTime = serverDate.toLocaleTimeString(undefined, timeOptions); 
    return `${formattedDate} ${center_text} ${formattedTime}`;
}